<template>
  <PbSimplePopup fitParentWidth :scrollToTop="false">
    <template #action="{ toggle, visible }">
      <div class="drop-down-list-toggle" :class="{ 'is-open': visible }" @click="handleOpen(); toggle()">
        <span class="drop-down-list-toggle__value">
          <slot name="value" />
        </span>
         <DropDownArrrow class="drop-down-list-toggle__icon"/>
      </div>
    </template>
    <template #default="{ hide }">
      <div class="drop-down-header">
        <img
          src="@kanoAssets/images/icons/circle-close.svg?url"
          width="24"
          height="24"
          alt="close"
          @click="hide"
        />
      </div>
      <PbScroll>
        <div class="drop-down-list">
          <slot name="default" :hide="hide" />
        </div>
      </PbScroll>
    </template>
  </PbSimplePopup>
</template>

<script setup lang="ts">
import PbScroll from "@kano/components/ExchangeFormV2/PbScroll.vue";
import PbSimplePopup from "@kano/components/Shared/PbSimplePopup.vue";
import DropDownArrrow from "@kanoAssets/images/icons/chevron-down.svg";

const emit = defineEmits<{
  (event: 'open'): void,
}>();

const handleOpen = () => {
  emit('open');
}

</script>

<style scoped lang="scss">
@use '@kanoAssets/styles/breakpoints.scss';

.drop-down-list-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  padding: 6px 12px;
  border: 1px solid var(--color-base);
  border-radius: 120px;
  gap: 8px;

  transition: border-color 150ms ease;

  &__icon {
    transition: color 150ms ease, transform 350ms ease;
  }

  &.is-open {
    border-color: var(--color-base-16);

    .drop-down-list-toggle__icon {
      transform: scaleY(-1);
      color: var(--color-primary);
    }
  }


  &:focus-within, &:hover {
    border-color: var(--color-base-8);
  }

  &__value {
    font-family: Inter Tight, Inter Tight fallback, sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
  }
}

.drop-down-header {
  display: flex;
  padding: 0 24px;
  justify-content: end;

  & img {
    cursor: pointer;
  }

  @include breakpoints.desktop {
    display: none;
  }
}

.drop-down-list {
  margin: 0 14px;
  max-height: 385px;
}

</style>